<ng-container *ngFor="let parent of controlArray.controls ; let i = index">
  <ng-container *ngFor="let child of parent.controls;  let j = index">
      <div *ngIf="child.value===true" class="filter-tag">
        {{label}}: {{dataSelect[i].items[j].child}} <a (click)="onRemoveOption(i, j)" class="remove" title="Eliminar"
              title="Eliminar">×</a>
      </div>
  </ng-container>
</ng-container>